// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CharacterList from './components/CharacterList';
import SingleCharacterDetail from './components/SingleCharacterDetail';
import ComicDetail from './components/ComicDetail';
import StoryList from './components/StoryList';
import ComicListList from './components/ComicList';
import CreatorList from './components/CreatorList';
import EventList from './components/EventList';
import SeriesList from './components/SeriesList';
import SingleStoryDetail from './components/SingleStoryDetail.js';
import SingleEventDetail from './components/SingleEventDetail.js';
import SingleSeriesDetail from './components/SingleSeriesDetail.js';
import SingleCreatorDetail from './components/SingleCreatorDetail.js';
import HomePage from './components/HomePage.js';


const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/characters/" element={<CharacterList />} />
        <Route path="/characters/:characterId" element={<SingleCharacterDetail />} />
        <Route path="/comics/:comicId" element={<ComicDetail />} />
        <Route path="/stories/" element={<StoryList />} />
        <Route path="/comics/" element={<ComicListList />} />
        <Route path="/creators/" element={<CreatorList />} />
        <Route path="/events/" element={<EventList />} />
        <Route path="/series/" element={<SeriesList />} />
        <Route path="/story/:storyId" element={<SingleStoryDetail />} />
        <Route path="/event/:eventId" element={<SingleEventDetail />} />
        <Route path="/serie/:seriesId" element={<SingleSeriesDetail />} />
        <Route path="/creator/:creatorId" element={<SingleCreatorDetail />} />
      </Routes>
    </Router>
    
  );
};

export default App;
